import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS } from "../apiEndpoints";

export const legalLibrarySearchApi = (payload) =>
  apiClient.post(`${BACKEND_ENDPOINTS.SEARCH_BASE_URL}${BACKEND_ENDPOINTS.LEGAL_LIBRARY_SEARCH}`, payload);

export const getUserFavoritesApi = (userId) =>
  apiClient.get(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.GET_USER_FAVORITES}`, { userId });

export const getPdfFromBlobStorageApi = (blob) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.SEARCH_BASE_URL}${BACKEND_ENDPOINTS.GET_PDF_FROM_BLOB_STORAGE}`,
    { blob },
    { responseType: "url" }
  );

export const removeFavoriteApi = (userId, statuteId) =>
  apiClient.delete(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.REMOVE_FAVORITE}`, {
    userId,
    statuteId,
  });

export const addFavoriteApi = (userId, statuteId) =>
  apiClient.post(`${BACKEND_ENDPOINTS.BASE_URL}${BACKEND_ENDPOINTS.ADD_FAVORITE}`, {
    userId,
    statuteId,
  });
